'use client';

import { Suspense } from 'react';

import AnalyticsLogger from './logger/analytics-logger.component';

import { LocationSelectionModal } from '@/app/(main)/(pages)/(home)/_components/location/_components/location-selection-modal.component';
import { LoadNProgressRouter } from '@/app/(main)/(pages)/(autoload)/load-nprogress-router/load-nprogress-router.component';
import { SearchModal } from '@/app/(main)/_components/search-modal/search-modal.component';
import ScrollToTop from '@/components/ui/scroll-to-top.component';
import { Toaster } from '@/components/ui/toaster.component';

export function ClientProviders() {
  return (
    <>
      <AnalyticsLogger />
      <LoadNProgressRouter />
      <ScrollToTop />
      <Toaster />
      <Suspense>
        <SearchModal />
        <LocationSelectionModal />
      </Suspense>
    </>
  );
}
